export default {
  element_selector: ".lazy",
  class_loading: "lazy--loading",
  class_loaded: "lazy--loaded",
  class_error: "lazy--error"
};



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/configureLazyLoad.js